import {DotIcon} from '@primer/octicons-react'

import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'
import iconStyles from '../../Icon.module.css'

export function AfterStatusIcon({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.After) return null

  return (
    <DotIcon
      size={16}
      className={`color-fg-muted ${iconStyles.alignedAfterDot}`}
      aria-label="Will not merge: higher up the stack"
    />
  )
}
